import React from 'react';
import { Box, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ClientsFilterChips = ({ filters, onChange }) => {
  const { t } = useTranslation();

  if (!filters) return null;

  const chips = [];

  if (filters.assignedToMe) {
    chips.push({
      key: 'assignedToMe',
      label: t('clients.filters.assignedToMe'),
      onDelete: () => onChange({ ...filters, assignedToMe: false }),
    });
  }
  if (filters.hasActiveConversation) {
    chips.push({
      key: 'hasActiveConversation',
      label: t('clients.filters.hasActiveConversation'),
      onDelete: () => onChange({ ...filters, hasActiveConversation: false }),
    });
  }
  if (filters.lastActivityWindow) {
    chips.push({
      key: 'lastActivityWindow',
      label: `${t('clients.filters.lastActivity')}: ${t(`clients.filters.lastActivity_${filters.lastActivityWindow}`)}`,
      onDelete: () => onChange({ ...filters, lastActivityWindow: null }),
    });
  }
  if (filters.city?.trim()) {
    chips.push({
      key: 'city',
      label: `${t('clients.filters.city')}: ${filters.city}`,
      onDelete: () => onChange({ ...filters, city: '' }),
    });
  }
  if (filters.state?.trim()) {
    chips.push({
      key: 'state',
      label: `${t('clients.filters.state')}: ${filters.state}`,
      onDelete: () => onChange({ ...filters, state: '' }),
    });
  }

  if (chips.length === 0) return null;

  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 1.5 }}>
      {chips.map((c) => (
        <Chip
          key={c.key}
          label={c.label}
          size="small"
          onDelete={c.onDelete}
          color="primary"
          variant="outlined"
        />
      ))}
    </Box>
  );
};

export default ClientsFilterChips;
